import { z } from "zod";
import { createJsonStorage } from "@/lib/storage/create-json-storage";

export type TimerDisplayMode = "simple" | "calendar" | "timeline";

const displayModeSchema = z.enum(["simple", "calendar", "timeline"]);

const displayModeStorage = createJsonStorage({
	key: "tg.timer.displayMode",
	schema: displayModeSchema,
	fallback: "calendar",
});

const lastProjectModeStorage = createJsonStorage({
	key: "tg.timer.lastProjectMode",
	schema: displayModeSchema,
	fallback: "calendar",
});

/** True when the user (or an older session) has written a display mode locally. */
export const hasStoredDisplayMode = (): boolean => displayModeStorage.has();

export const readStoredDisplayMode = (): TimerDisplayMode => displayModeStorage.get();

/** Last project-hours view, used when leaving working hours back to project hours. */
export const readLastProjectDisplayMode = (fallback: TimerDisplayMode = "calendar"): TimerDisplayMode =>
	lastProjectModeStorage.has() ? lastProjectModeStorage.get() : fallback;

export const writeActiveDisplayMode = (next: TimerDisplayMode): void => {
	displayModeStorage.set(next);
};

export const writeDisplayMode = (next: TimerDisplayMode): void => {
	writeActiveDisplayMode(next);
	lastProjectModeStorage.set(next);
};

/** Current project-hours display mode (simple, calendar, or timeline). */
export const useStoredDisplayMode = (): TimerDisplayMode => displayModeStorage.useValue();
